import React, { createContext, Dispatch, useContext, useReducer } from 'react';

import {
  CompanyDocumentsContextActions,
  CompanyDocumentsContextActionTypes,
  CompanyDocumentsProps,
  CompanyDocumentsProviderProps,
} from './CompanyDocumentsContext.types';

const CompanyDocumentsContext = createContext<CompanyDocumentsProps | undefined>(undefined);
const CompanyDocumentsDispatchContext = createContext<
  Dispatch<CompanyDocumentsContextActions> | undefined
>(undefined);

const initialCompanyDocumentsState: CompanyDocumentsProps = {
  selectedFiles: [],
};

const CompanyDocumentsReducer = (
  state: CompanyDocumentsProps,
  action: CompanyDocumentsContextActions,
) => {
  switch (action.type) {
    case CompanyDocumentsContextActionTypes.SetInitial: {
      return { ...state };
    }
    case CompanyDocumentsContextActionTypes.SelectFiles: {
      return {
        ...state,
        selectedFiles: action.payload,
      };
    }
  }
};

export const CompanyDocumentsContextProvider = ({ children }: CompanyDocumentsProviderProps) => {
  const [state, dispatch] = useReducer(CompanyDocumentsReducer, initialCompanyDocumentsState);

  return (
    <CompanyDocumentsContext.Provider value={state}>
      <CompanyDocumentsDispatchContext.Provider value={dispatch}>
        {children}
      </CompanyDocumentsDispatchContext.Provider>
    </CompanyDocumentsContext.Provider>
  );
};

export const useCompanyDocumentsState = () => {
  const context = useContext(CompanyDocumentsContext);

  if (context === undefined) {
    throw new Error('CompanyDocumentsState must be used within a CompanyDocumentsProvider');
  }

  return context;
};

export const useCompanyDocumentsDispatch = () => {
  const context = useContext(CompanyDocumentsDispatchContext);

  if (context === undefined) {
    throw new Error('CompanyDocumentsDispatch must be used within a CompanyDocumentsProvider');
  }

  return context;
};
